module.exports = __webpack_public_path__ + "static/14-b334deb787125e120a298f5e3da0d5ca.jpg";